import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getStudentsForOnlineAttendance, markOnlineAttendance } from '../services/api';
import { useLanguage } from '../LanguageContext';

function OnlineAttendancePage() {
  const navigate = useNavigate();
  const { language, setLanguage, t } = useLanguage();
  const [date, setDate] = useState(() => {
    const today = new Date();
    const day = today.getDay();
    if (day === 5 || day === 6) return today.toISOString().split('T')[0];
    const daysUntilFriday = (5 - day + 7) % 7 || 7;
    const nextFriday = new Date(today);
    nextFriday.setDate(today.getDate() + daysUntilFriday);
    return nextFriday.toISOString().split('T')[0];
  });
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAttendanceMenu, setShowAttendanceMenu] = useState(true);
  const username = localStorage.getItem('username');

  useEffect(() => {
    loadStudents();
  }, [date]);

  const loadStudents = async () => {
    setLoading(true);
    try {
      const response = await getStudentsForOnlineAttendance(date);
      setStudents(response.data);
    } catch (error) {
      console.error('Failed to load students');
    } finally {
      setLoading(false);
    }
  };

  const handleMarkAttendance = async (applicationNumber, present) => {
    try {
      await markOnlineAttendance({ applicationNumber, date, present, markedBy: username });
      loadStudents();
    } catch (error) {
      alert('Failed to mark attendance');
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  return (
    <div style={{display: 'flex', minHeight: '100vh'}}>
      <div style={{width: '250px', backgroundColor: '#f8f9fa', borderRight: '1px solid #dee2e6', padding: '20px'}}>
        <div style={{marginBottom: '30px', textAlign: 'center'}}>
          <img src="/misk_logo.png" alt="MISK Logo" style={{height: '60px'}} />
        </div>
        <nav>
          <div 
            style={{padding: '12px', cursor: 'pointer', borderRadius: '5px', color: '#2d5f3f', fontWeight: '500', marginBottom: '10px'}}
            onClick={() => navigate('/dashboard')}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#e8f5e9'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            📊 Dashboard
          </div>
          <div 
            style={{padding: '12px', cursor: 'pointer', borderRadius: '5px', color: '#2d5f3f', fontWeight: '500', marginBottom: '10px'}}
            onClick={() => navigate('/dashboard')}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#e8f5e9'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            👥 Students
          </div>
          <div style={{marginBottom: '10px'}}>
            <div 
              style={{padding: '12px', cursor: 'pointer', borderRadius: '5px', backgroundColor: showAttendanceMenu ? '#e8f5e9' : 'transparent', color: '#2d5f3f', fontWeight: '500'}}
              onClick={() => setShowAttendanceMenu(!showAttendanceMenu)}
            >
              📋 Attendance {showAttendanceMenu ? '▼' : '▶'}
            </div>
            {showAttendanceMenu && (
              <>
                <div 
                  style={{paddingLeft: '30px', paddingTop: '8px', cursor: 'pointer', padding: '8px 8px 8px 30px', borderRadius: '5px', color: '#555'}}
                  onClick={() => navigate('/attendance-sheet')}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#e8f5e9'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                >
                  Generate Sheet
                </div>
                <div 
                  style={{paddingLeft: '30px', cursor: 'pointer', padding: '8px 8px 8px 30px', borderRadius: '5px', color: '#555'}}
                  onClick={() => navigate('/upload-attendance')}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#e8f5e9'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                >
                  Upload Offline Sheet
                </div>
                <div 
                  style={{paddingLeft: '30px', cursor: 'pointer', padding: '8px 8px 8px 30px', borderRadius: '5px', backgroundColor: '#e8f5e9', color: '#555', fontWeight: '500'}}
                >
                  Online Attendance
                </div>
              </>
            )}
          </div>
        </nav>
      </div>

      <div style={{flex: 1}}>
        <div className="container">
          <div className="header">
            <h1 style={{margin: 0}}>Online Attendance</h1>
            <div style={{display: 'flex', alignItems: 'center', gap: '15px'}}>
              <select value={language} onChange={(e) => setLanguage(e.target.value)} className="lang-select">
                <option value="en">English</option>
                <option value="ta">தமிழ்</option>
                <option value="ar">العربية</option>
              </select>
              <span>Welcome, {username}</span>
              <button className="btn btn-logout" onClick={handleLogout}>{t('logout')}</button>
            </div>
          </div>

          <div className="card">
            <div style={{marginBottom: '20px'}}>
              <label style={{fontWeight: 'bold', marginRight: '10px'}}>Select Date:</label>
              <input 
                type="date" 
                value={date}
                onChange={(e) => setDate(e.target.value)}
                style={{padding: '8px', fontSize: '16px', borderRadius: '5px', border: '1px solid #ddd'}}
              />
              <span style={{marginLeft: '15px', color: '#666'}}>
                {new Date(date + 'T00:00:00').toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
              </span>
            </div>

            {loading ? (
              <div style={{textAlign: 'center', padding: '60px 0'}}>
                <div className="spinner"></div>
              </div>
            ) : (
              <table className="table">
                <thead>
                  <tr>
                    <th>App No.</th>
                    <th>Student Name</th>
                    <th>Father Name</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {students.map(student => (
                    <tr key={student.id}>
                      <td><strong>{student.applicationNumber}</strong></td>
                      <td>{student.studentName}</td>
                      <td>{student.fatherName}</td>
                      <td>
                        <span style={{
                          padding: '5px 10px',
                          borderRadius: '5px',
                          backgroundColor: student.present ? '#4caf50' : '#f44336',
                          color: 'white',
                          fontWeight: 'bold'
                        }}>
                          {student.present ? 'Present' : 'Absent'}
                        </span>
                      </td>
                      <td>
                        <button 
                          className="btn btn-primary" 
                          onClick={() => handleMarkAttendance(student.applicationNumber, true)}
                          disabled={student.present}
                          style={{marginRight: '10px', opacity: student.present ? 0.5 : 1}}
                        >
                          Mark Present
                        </button>
                        <button 
                          className="btn btn-logout" 
                          onClick={() => handleMarkAttendance(student.applicationNumber, false)}
                          disabled={!student.marked || !student.present}
                          style={{opacity: (!student.marked || !student.present) ? 0.5 : 1}}
                        >
                          Mark Absent
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default OnlineAttendancePage;
